import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { Modal } from '@/modules/modals';
import { SubscriptionRequiredAlert } from '@/modules/saas-upgrade';
import { useHasSharingPermissions, useIsFreeTier } from '@/modules/settings/hooks';
import { Heading } from '@/modules/ui';

import { isPublicSharingActive } from '../../utilities';
import { useSecretDetailContext } from '../SecretDetail/SecretDetailProvider';
import { SharePrivateLink } from './SharePrivateLink';
import { ShareSecretForm } from './ShareSecretForm';
import { ShareSecretInfo } from './ShareSecretInfo';
import * as felaRules from './ShareSecretModal.rules';

export interface ShareSecretButtonProps {
    open: boolean;
    onClose: () => void;
}

export const ShareSecretModal = ({ open, onClose }: ShareSecretButtonProps) => {
    const { css } = useFela();
    const { id, userPermissions, share } = useSecretDetailContext();
    const isFreeTier = useIsFreeTier();
    const { getHasSharingPermissions } = useHasSharingPermissions();

    const canUserShare = getHasSharingPermissions(userPermissions);

    return (
        <Modal
            open={open}
            onClose={onClose}
            closable
            width={520}
            extend={{
                buttons: felaRules.buttons,
            }}
            dataTestId='share-secret-modal'
        >
            <Heading elementType='h2' color='black'>
                <FormattedMessage id='secret.modal.share.title' />
            </Heading>
            <div className={css(felaRules.sharingContainer)}>
                <ShareSecretForm id={id} share={share} canUserShare={canUserShare} />
                {canUserShare && isPublicSharingActive(share) && <ShareSecretInfo id={id} share={share} />}
            </div>

            {isFreeTier && <SubscriptionRequiredAlert message='secret.share.upgrade' />}

            <div className={css(felaRules.privateLinkContainer)}>
                <SharePrivateLink />
            </div>
        </Modal>
    );
};
